import { FileCheck2, Landmark, ShieldCheck, Users } from 'lucide-react';
import Hotspot from './Hotspot';

const STEPS = [
  { label: 'Evidence attached', icon: FileCheck2, done: true },
  { label: 'Witness confirmed', icon: Users, done: true },
  { label: 'Institution confirmed', icon: Landmark, done: true },
] as const;

/** Fictional preview only. Identity: Sophie Lin (see @/lib/demo-content). No real user data. */
export default function TrustRecordPreview() {
  return (
    <div className="relative min-w-0">
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="truncate text-sm font-bold text-slate-900">BSc Computer Science</p>
          <p className="truncate text-xs text-slate-500">Degree record &middot; Sophie Lin</p>
        </div>
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-[#eaf3de] px-2.5 py-1 text-[10px] font-bold text-[#3b6d11]">
          <ShieldCheck size={12} aria-hidden="true" />
          Active
        </span>
      </div>

      <div className="mt-4 space-y-2">
        {STEPS.map((step) => {
          const Icon = step.icon;
          return (
            <div
              key={step.label}
              className="flex items-center gap-2.5 rounded-[9px] border border-slate-200 bg-white p-2.5"
            >
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#162e40] text-[#a9d9f2]">
                <Icon size={14} aria-hidden="true" />
              </span>
              <p className="min-w-0 flex-1 truncate text-xs font-bold text-slate-800">
                {step.label}
              </p>
              <span className="shrink-0 rounded-full bg-[#eef6fb] px-2 py-0.5 text-[10px] font-bold text-[#1e6091]">
                Confirmed
              </span>
            </div>
          );
        })}
      </div>

      <div className="relative mt-4 flex items-center gap-3 rounded-[9px] border border-[#5fa8d3]/30 bg-[#eef6fb] p-3">
        <div className="min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-wide text-[#1e6091]">
            Record status
          </p>
          <p className="mt-1 text-sm leading-6 text-slate-700">
            Reviewed and confirmed by the issuing institution. Visible on a public trust page when
            shared.
          </p>
        </div>
        <Hotspot
          label="View evidence"
          note="Supporting documents stay attached to the credential so reviewers can see the source."
          className="absolute -bottom-3 left-3"
        />
        <Hotspot
          label="See recognition"
          note="Confirmed credentials can be shared as a public, verifiable trust page."
          className="absolute -bottom-3 right-3"
        />
      </div>
    </div>
  );
}
